/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconMobileXClose from '@telus-uds/palette-public-mobile/build/rn/icons/MobileXClose'
import PaletteIconCheckMark from '@telus-uds/palette-public-mobile/build/rn/icons/CheckMark'
import PaletteIconWarningError from '@telus-uds/palette-public-mobile/build/rn/icons/WarningError'
const theme = {
  appearances: {
    style: {
      type: 'variant',
      values: [ 'system', 'success', 'warning', 'error', 'subtle' ]
    },
    system: { type: 'state', values: [ true ] },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning' ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { system: true, viewport: [ 'xl' ] },
      tokens: { containerPaddingLeft: 16, containerPaddingRight: 16 }
    },
    {
      if: { system: true },
      tokens: {
        borderLeftWidth: 0,
        borderRadius: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 16,
        paddingBottom: 12,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 12
      }
    },
    {
      if: { style: 'system' },
      tokens: {
        borderLeftWidth: 0,
        borderRadius: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 16,
        paddingBottom: 12,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 12
      }
    },
    {
      if: { style: 'subtle' },
      tokens: {
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderRadius: 6,
        borderRightWidth: 0,
        borderTopWidth: 0,
        iconGap: 16,
        paddingBottom: 12,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 12
      }
    },
    {
      if: { style: 'success' },
      tokens: {
        backgroundColor: '#2b826e',
        color: '#ffffff',
        dismissIconColor: '#ffffff',
        icon: PaletteIconCheckMark,
        iconColor: '#ffffff'
      }
    },
    {
      if: { validation: 'success' },
      tokens: {
        backgroundColor: '#2b826e',
        color: '#ffffff',
        dismissIconColor: '#ffffff',
        icon: PaletteIconCheckMark,
        iconColor: '#ffffff'
      }
    },
    {
      if: { style: 'warning' },
      tokens: {
        backgroundColor: '#fce6df',
        dismissIcon: null,
        icon: PaletteIconWarningError,
        iconColor: '#394056'
      }
    },
    {
      if: { validation: 'warning' },
      tokens: {
        backgroundColor: '#fce6df',
        dismissIcon: null,
        icon: PaletteIconWarningError,
        iconColor: '#394056'
      }
    },
    {
      if: { style: 'error' },
      tokens: {
        backgroundColor: '#bf1722',
        color: '#ffffff',
        dismissIcon: null,
        icon: PaletteIconWarningError,
        iconColor: '#ffffff'
      }
    },
    {
      if: { validation: 'error' },
      tokens: {
        backgroundColor: '#bf1722',
        color: '#ffffff',
        dismissIcon: null,
        icon: PaletteIconWarningError,
        iconColor: '#ffffff'
      }
    }
  ],
  tokens: {
    backgroundColor: '#d8dae2',
    borderBottomWidth: 0,
    borderColor: null,
    borderLeftWidth: 0,
    borderRadius: 6,
    borderRightWidth: 0,
    borderTopWidth: 0,
    color: '#394056',
    containerPaddingLeft: 0,
    containerPaddingRight: 0,
    dismissButtonGap: 12,
    dismissIcon: PaletteIconMobileXClose,
    dismissIconColor: '#394056',
    fontName: 'SofiaPro',
    fontSize: 18,
    fontWeight: '400',
    icon: null,
    iconColor: null,
    iconGap: 16,
    iconSize: 24,
    justifyContent: 'flex-start',
    lineHeight: 1.55555555,
    paddingBottom: 12,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 12
  }
}
export default theme
